import React, { useState } from 'react';

// VIN Display Component - Shows full VIN with copy button and last 8/6 highlighting
// Consistent format across all modules: full VIN on one line, last 8 bold, last 6 super bold + larger
const VinDisplay = ({ vin, className = '' }) => {
  const [copied, setCopied] = useState(false);
  
  // Safety check - ensure vin is a string
  if (!vin || typeof vin !== 'string') return <span className={`text-neutral-400 ${className}`}>-</span>;
  
  const prefix = vin.slice(0, -8);
  const middle = vin.slice(-8, -6);
  const last6 = vin.slice(-6);
  
  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(vin);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };
  
  return (
    <span className={`inline-flex items-center gap-1 font-mono text-xs ${className}`}>
      <span className="text-neutral-400">{prefix}</span>
      <span className="font-semibold text-neutral-600">{middle}</span>
      <span className="font-bold text-neutral-900 text-sm">{last6}</span>
      <button
        onClick={handleCopy}
        className="ml-1 p-0.5 text-neutral-400 hover:text-blue-600 hover:bg-blue-50 rounded"
        title={copied ? 'Copied!' : 'Copy VIN'}
      >
        {copied ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
        )}
      </button>
    </span>
  );
};

export default VinDisplay;
